import createReactComponent from '../createReactComponent';
export default createReactComponent('wave-saw-tool', 'IconWaveSawTool', [
  ['path', { d: 'M3 12h5l4 8v-16l4 8h5', key: 'svg-0' }],
]);
